export interface Location {
  left: number;
  top: number;
  right: number;
  bottom: number;
}

export interface TextLocation {
  location: Location;
  name: string;
  text: string;
}
export interface Element {
  location: Location;
  name: string;
  label?: TextLocation;
}

export interface ComponentsJsonResponseWithCompactStr {
  components: Element[];
  modelVersion: string;
  compactStrings: string[];
}

export interface LabelboxDataRowBody {
  gsPath: string;
  sourceTable?: string;
  sourceTableDataId?: string;
  attachmentType?: string;
  attachmentValue?: string;
}

export enum ServiceType {
  componentRecognition = 'ComponentRecognition',
  ocr = 'OCR',
}
